import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { MaskTypeEnum } from 'src/app/shared/input/enums/mask-type.enum';
import {
  GetClientRequest,
  GetClientsResponse,
} from '../../client/models/client.model';
import { ClientService } from '../../client/service/client.service';
import {
  CreateIncidentsImportRequest,
  GetAudiosIncidentsImportRequest,
} from '../incidents-import.model';
import { IncidentsImportService } from '../incidents-import.service';
import { PagedRequest } from 'src/app/paged-request.model';
import { Observable, tap, catchError, of } from 'rxjs';
import { SkillService } from 'src/app/common/services/skill/skill.service';

@Component({
  selector: 'app-incidents-import-new',
  templateUrl: './incidents-import-new.component.html',
  styleUrls: ['./incidents-import-new.component.scss'],
})
export class IncidentsImportNewComponent implements OnInit {
  constructor(
    public formBuilder: FormBuilder,
    public service: IncidentsImportService,
    public toastrService: ToastrService,
    public router: Router,
    private clientService: ClientService,
    private skillService: SkillService
  ) {}

  isLoading: boolean = false;

  errorMessageQuantity: string = 'campo obrigatório';
  quantityError: boolean = false;

  clients: string[] = [];
  originalClients: GetClientsResponse[] = [];
  clientsError: boolean = false;

  cellsError: boolean = false;
  cellsDisabled: boolean = false;
  cellsPlaceHolder: string = 'Selecione uma célula';

  subCellsDisabled: boolean = false;
  subCellsPlaceHolder: string = 'Selecione uma sub-célula';

  ButtonColorEnum = ButtonColorEnum;
  MaskTypeEnum = MaskTypeEnum;
  InputTypeEnum = InputTypeEnum;

  step: number = 0;
  availableAudios: number = 0;

  loadingClients: boolean = false;
  loadingSearchClients: boolean = false;
  loadingMoreClients: boolean = false;
  totalItemsClients: number = 0;
  clientFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name',
  } as GetClientRequest;

  loadingCells: boolean = false;
  loadingSearchCells: boolean = false;
  loadingMoreCells: boolean = false;
  totalItemsCells: number = 0;
  cells: string[] = [];
  selectedCells: string[] = [];
  cellsFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortAscending: true,
    sortBy: 'Cell',
  } as PagedRequest;

  loadingSubcells: boolean = false;
  loadingSearchSubCells: boolean = false;
  loadingMoreSubCells: boolean = false;
  totalItemsSubCells: number = 0;
  selectedSubCells: string[] = [];
  subCells: string[] = [];
  subCellsFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortAscending: true,
    sortBy: 'SubCell',
  } as PagedRequest;

  form = this.formBuilder.group({
    serviceDate: ['', Validators.required],
    client: ['', Validators.required],
    cell: ['', Validators.required],
    subCell: [''],
    quantity: ['', Validators.required],
  });

  ngOnInit(): void {
    this.step = 1;
    this.loadingClients = true;

    this.getClients(null);
    this.getCells();
    this.getSubCells();

    this.form.controls.client.valueChanges.subscribe((value: string | null) => {
      this.form.controls.cell.reset();
      this.form.controls.subCell.reset();

      this.selectedCells = [];
      this.selectedSubCells = [];

      if (this.form.controls.client.status == 'INVALID')
        this.clientsError = true;
      else {
        if (value) {
          let clientId = this.getClientIdFromText(value);
          let client = this.originalClients.find((x) => x.id == clientId);
          if (client) {
            if (client.name == 'COMGÁS') {
              this.cells = [
                'COMGAS 08000',
                'COMGAS CONTAS',
                'EMERGENCIA',
                'COMGAS EMERGENCIA',
                'ACOMPANHAMENTO OBRAS',
              ];
              this.subCells = Array.from(
                new Set(
                  client.skills
                    .filter((c) => this.cells.includes(c.cell))
                    .map((i) => i.subCell)
                )
              );
            } else {
              this.cells = Array.from(
                new Set(client.skills.map((i) => i.cell))
              );
              this.subCells = Array.from(
                new Set(client.skills.map((i) => i.subCell))
              );
            }

            if (this.cells.length == 0) {
              this.cellsDisabled = true;
              this.cellsPlaceHolder =
                'Não há células disponíveis para este cliente';
            } else {
              this.cellsDisabled = false;
              this.cellsPlaceHolder = 'Selecione uma célula';
            }
            if (this.subCells.length == 0) {
              this.subCellsDisabled = true;
              this.subCellsPlaceHolder =
                'Não há sub-células disponíveis para este cliente';
            } else {
              this.subCellsDisabled = false;
              this.subCellsPlaceHolder = 'Selecione uma sub-célula';
            }
          }
        }
        this.clientsError = false;
      }
    });

    this.form.controls.cell.valueChanges.subscribe(() => {
      if (this.form.controls.cell.status == 'INVALID') this.cellsError = true;
      else this.cellsError = false;
    });

    this.form.controls.quantity.valueChanges.subscribe(() => {
      this.errorMessageQuantity = 'campo obrigatório';
    });
  }

  getClients(name: string | null) {
    this.clientFilter.pageNumber = 1;

    if (name) {
      this.clientFilter.name = name;
      this.loadingSearchClients = true;
    } else {
      this.loadingClients = true;
      this.clientFilter.name = null;
    }

    this.clientService.get(this.clientFilter).subscribe({
      next: (data) => {
        this.originalClients = data.items;
        this.clients = data.items.map((i) => i.name + ' | ' + i.cnpj);
        this.totalItemsClients = data.totalItems;
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os clientes.');
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
    });
  }

  getMoreClients() {
    if (this.totalItemsClients != this.clients.length) {
      this.loadingMoreClients = true;
      if (this.clientFilter.pageNumber) this.clientFilter.pageNumber += 1;

      this.clientService.get(this.clientFilter).subscribe({
        next: (data) => {
          this.originalClients = this.originalClients.concat(data.items);
          this.totalItemsClients = data.totalItems;
          this.clients = this.clients.concat(
            data.items.map((i) => i.name + ' | ' + i.cnpj)
          );
          this.loadingMoreClients = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os clientes.');
          this.loadingMoreClients = false;
        },
      });
    }
  }

  getCells() {
    this.cellsFilter.pageNumber = 1;
    this.loadingCells = true;

    this.skillService.getCells(this.cellsFilter).subscribe({
      next: (data) => {
        this.cells = data.items;
        this.totalItemsCells = data.totalItems;
        this.loadingCells = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as células.');
        this.loadingCells = false;
      },
    });
  }

  getMoreCells() {
    if (this.totalItemsCells != this.cells.length) {
      this.loadingMoreCells = true;
      if (this.cellsFilter.pageNumber) this.cellsFilter.pageNumber += 1;

      this.skillService.getCells(this.cellsFilter).subscribe({
        next: (data) => {
          this.cells = this.cells.concat(data.items);
          this.totalItemsCells = data.totalItems;
          this.loadingMoreCells = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as células.');
          this.loadingMoreCells = false;
        },
      });
    }
  }

  getSubCells() {
    this.subCellsFilter.pageNumber = 1;
    this.loadingSubcells = true;

    this.skillService.getSubCells(this.subCellsFilter).subscribe({
      next: (data) => {
        this.subCells = data.items;
        this.totalItemsSubCells = data.totalItems;
        this.loadingSubcells = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar as sub-células.');
        this.loadingSubcells = false;
      },
    });
  }

  getMoreSubCells() {
    if (this.totalItemsSubCells != this.subCells.length) {
      this.loadingMoreSubCells = true;
      if (this.subCellsFilter.pageNumber) this.subCellsFilter.pageNumber += 1;

      this.skillService.getSubCells(this.subCellsFilter).subscribe({
        next: (data) => {
          this.subCells = this.subCells.concat(data.items);
          this.totalItemsSubCells = data.totalItems;
          this.loadingMoreSubCells = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar as sub-células.');
          this.loadingMoreSubCells = false;
        },
      });
    }
  }

  getClientIdFromText(text: string): string {
    if (!text) return '';
    let clientName = text.split('|')[0].trim();
    let client = this.originalClients.find(
      (i) => i.name.trim() === clientName.trim()
    );
    if (client) return client.id;
    else return '';
  }

  handleNavigateBack() {
    this.router.navigate(['/incidents-import/']);
  }

  handleNextStep() {
    Object.keys(this.form.controls).forEach((key) => {
      const control =
        this.form.controls[key as keyof typeof this.form.controls];
      if (control.status == 'INVALID') control.markAsDirty();
    });

    if (this.form.controls.client.status == 'INVALID') this.clientsError = true;
    if (this.form.controls.cell.status == 'INVALID') this.cellsError = true;

    if (this.form.controls.quantity.value?.trim() == '0') {
      this.quantityError = true;
      this.errorMessageQuantity = 'quantidade não pode ser 0';
      return;
    }

    if (!this.form.valid || this.isLoading) return;

    this.isLoading = true;

    var request = {
      serviceDate: this.form.controls.serviceDate.value ?? '',
      clientId:
        this.getClientIdFromText(this.form.controls.client.value ?? '') ?? '',
      cell: this.form.controls.cell.value ?? '',
      subCell: this.form.controls.subCell.value ?? '',
    } as GetAudiosIncidentsImportRequest;

    this.service.getAudios(request).subscribe({
      next: (data) => {
        this.isLoading = false;
        this.availableAudios = data;
        this.step = 2;
        this.quantityError = false;
      },
      error: () => {
        this.isLoading = false;
        this.toastrService.error(
          'Ocorreu um erro ao buscar áudios disponíveis para importação de atendimentos.'
        );
      },
    });
  }

  validQuantity(): boolean {
    var quantity = this.form.controls.quantity.value ?? 0;
    if (quantity == 0) return false;
    return this.availableAudios >= Number(quantity);
  }

  create() {
    this.isLoading = true;

    var request = {
      serviceDate: this.form.controls.serviceDate.value ?? '',
      clientId:
        this.getClientIdFromText(this.form.controls.client.value ?? '') ?? '',
      cell: this.form.controls.cell.value ?? '',
      subCell: this.form.controls.subCell.value ?? null,
      requestQty: this.form.controls.quantity.value ?? 0,
    } as CreateIncidentsImportRequest;

    this.service.post(request).subscribe({
      next: () => {
        this.isLoading = false;
        this.toastrService.success(
          'Importação de atendimentos registrada com sucesso.'
        );
        this.router.navigate(['/incidents-import']);
      },
      error: () => {
        this.isLoading = false;
        this.toastrService.error(
          'Ocorreu um erro ao registrar importação de atendimentos.'
        );
      },
    });
  }
}
